// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"styles_carouselContainer__KGa0J","boxContainer":"styles_boxContainer__UAKcP","labelContainer":"styles_labelContainer__5W6Bj"};